import { Modal, Text, Button } from '@desygner/ui-common-components';
import React, { useState } from 'react';
import ReactAppBuilder from 'src/utils/react-app-builder';

class ActionPrompt extends ReactAppBuilder {
  constructor ({ appId, targetNodeSelector }) {
    super({ appId, targetNodeSelector });
    this.labels = {};
    this.onClick = null;
  }

  mountApp ({ labels, onClick }) {
    this.labels = labels;
    this.onClick = onClick;
    super.mountApp(this.App);
  }

  closeApp () {
    this.labels = {};
    this.onClick = null;
    super.closeApp(this.App);
  }

  handleClick (callback) {
    this.onClick?.();
    callback();
  }

  App = () => {
    const [loading, setLoading] = useState(false);

    return (
      <Modal>
        <Text size={'DisplayMedium'}>{this.labels.title}</Text>
        <div style={{ textAlign: 'center' }}>
          <Text size={'Body'}>{this.labels.subtitle}</Text>
        </div>
        <Button
          onClick={this.handleClick.bind(this, () => setLoading(true))}
          loading={loading}
          disabled={loading}
          label={loading ? this.labels.button.loading : this.labels.button.title}
        />
      </Modal>
    );
  };
}

export default new ActionPrompt({
  appId: 'react-action-prompt-app',
  targetNodeSelector: 'body'
});
